import { observable } from "mobx";
import MOTService from "../../../services/MOTService";
import { getMensagemDeErro } from "../../../utils/functions";

export default class CalculoCustoMotStore {
//RHFPP-1548 - Consulta Custo Mot
    @observable filtros;
    @observable loading;
    @observable loadingLotacoesGlobo;
    @observable carregando;

    @observable dadosCalculo;
    @observable respostaCalculo;

    constructor(props) {
        this.loading = false;
        this.loadingLotacoesGlobo = false;

        this.MOTService = new MOTService();

        //this.resetFiltros();

        this.carregando = false;
    }

    calcular = (filtro) => {
        this.respostaCalculo =[];
        this.carregando = true;
        this.erro = null;

        const loadingPromises = Promise.all([
            this.MOTService.calcularCustoMot(filtro).then(response => {
                this.dadosCalculo = response.data;
                this.montaResposta();
            }).catch(error => {
                this.erro = getMensagemDeErro(error);
                this.carregando = false;
            })
        ]);

        loadingPromises.then(
            () => {
                this.loading = false;
                this.carregando = false;
            }
        ).catch(
            (error) => this.loading = false
        );
    }

    resetFiltros = () => {
        this.filtros = {};
    };

    carregarTabela = () => {
        this.loading = true;
    };

    getNomeCargo = () => {
        
        return this.dadosCalculo != null 
        ? this.dadosCalculo.cargoNome +" ("+this.dadosCalculo.cargoId + ")" 
        : "";
    }
    getSindicato = () => {
        return this.dadosCalculo != null 
        ? this.dadosCalculo.sindicato
        :"";
    }
    getCompetenciaCargo = () => {
        return this.dadosCalculo != null 
        ? this.dadosCalculo.competenciaCargo
        :"";
    }
    getJornadaMensal = () => {
        return this.dadosCalculo != null 
        ? this.dadosCalculo.cargoJornadaMensal
        :"";
    }
    getSalario = () => {
        return this.dadosCalculo != null 
        ? this.dadosCalculo.salarioBase
        :"";
    }
    getResultado = () => {
        return this.dadosCalculo != null && this.dadosCalculo.resultado != null
        ? this.dadosCalculo.resultado
        :"";
    }
    getMsgValidacao = () => {
        return this.dadosCalculo != null && this.dadosCalculo.msgValidacao != null
        ? this.dadosCalculo.msgValidacao
        :"";
    }
    getTituloSalarioBase = () =>{
        var tituloSalarioBase = "Salário Base";

        if (this.dadosCalculo != null && this.dadosCalculo.aplicarAche){
            tituloSalarioBase = "Salário Base + Ache (" + this.dadosCalculo.percentualAche + "%)";
        }
        return tituloSalarioBase;
    }
    montaResposta = () =>{

        let resultado = this.getResultado();
        let msgValidacao = this.getMsgValidacao();

        if (msgValidacao !=="" ){
            
            let tipo = resultado !== "" ? "alerta" : "erro";

            let reg = {"tipo": tipo, "mensagem": msgValidacao};

            this.respostaCalculo.push(reg);
        } 

        if (resultado !==""){
            let regOk = {"tipo": "ok", "mensagem": resultado};

            this.respostaCalculo.push(regOk);
        }
    }
}